const PRODUCTS_PREFIX = '@@products/';

export const PRODUCTS_ACTION_TYPES = {
    FETCH_LIST_REQUEST: `${PRODUCTS_PREFIX}FETCH_LIST_REQUEST`,
    FETCH_LIST_SUCCESS: `${PRODUCTS_PREFIX}FETCH_LIST_SUCCESS`,
    FETCH_LIST_FAILURE: `${PRODUCTS_PREFIX}FETCH_LIST_FAILURE`,

    FETCH_ITEM_REQUEST: `${PRODUCTS_PREFIX}FETCH_ITEM_REQUEST`,
    FETCH_ITEM_SUCCESS: `${PRODUCTS_PREFIX}FETCH_ITEM_SUCCESS`,
    FETCH_ITEM_FAILURE: `${PRODUCTS_PREFIX}FETCH_ITEM_FAILURE`,

    FETCH_CATEGORY_REQUEST: `${PRODUCTS_PREFIX}FETCH_CATEGORY_REQUEST`,
    FETCH_CATEGORY_SUCCESS: `${PRODUCTS_PREFIX}FETCH_CATEGORY_SUCCESS`,
    FETCH_CATEGORY_FAILURE: `${PRODUCTS_PREFIX}FETCH_CATEGORY_FAILURE`,

    SEARCH_REQUEST: `${PRODUCTS_PREFIX}/SEARCH_REQUEST`,
    SEARCH_SUCCESS: `${PRODUCTS_PREFIX}/SEARCH_SUCCESS`,
    SEARCH_FAILURE: `${PRODUCTS_PREFIX}/SEARCH_FAILURE`,
    CLEAR_SEARCH:   `${PRODUCTS_PREFIX}/CLEAR_SEARCH`,

    FETCH_RELATED_REQUEST: `${PRODUCTS_PREFIX}FETCH_RELATED_REQUEST`,
    FETCH_RELATED_SUCCESS: `${PRODUCTS_PREFIX}FETCH_RELATED_SUCCESS`,
    FETCH_RELATED_FAILURE: `${PRODUCTS_PREFIX}FETCH_RELATED_FAILURE`,

    CLEAR_DATA: `${PRODUCTS_PREFIX}CLEAR_DATA`,
}

export const PRODUCTS_CONFIG = {
    PAGE_SIZE: 20,
    SHOWCASE_SIZE: 4,
    CACHE_TIME: 60 * 1000,
}